<tr {...$$restProps} on:click on:mouseover on:mouseenter on:mouseleave>
  <slot />
</tr>
